module.exports = __webpack_public_path__ + "static/media/login-page.2f0d3714.png";